/** Clear only the visitor's active Shopify cart, then reset this theme's order details. */
export async function clearCurrentCart(root, request = fetch) {
  const base = root.endsWith('/') ? root : `${root}/`;
  const options = {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  };

  const clearedResponse = await request(`${base}cart/clear.js`, options);
  if (!clearedResponse.ok) throw new Error('Could not clear the cart. Please try again.');
  const clearedCart = await clearedResponse.json();
  if (clearedCart.item_count !== 0) throw new Error('Could not verify that the cart is empty. Please try again.');

  // Shopify's clear endpoint leaves note, attributes, and discount codes behind.
  // Reset only this theme's PO attribute, not attributes owned by other apps.
  let updatedCart;
  try {
    const detailsResponse = await request(`${base}cart/update.js`, {
      ...options,
      body: JSON.stringify({ note: '', attributes: { 'PO / Job name': '' }, discount: '' }),
    });
    if (!detailsResponse.ok) return { detailsReset: false };
    updatedCart = await detailsResponse.json();
  } catch {
    return { detailsReset: false };
  }
  if (updatedCart.item_count !== 0) {
    // A fee reconciliation started before the click can finish after the first clear.
    const secondClear = await request(`${base}cart/clear.js`, options);
    if (!secondClear.ok || (await secondClear.json()).item_count !== 0) {
      throw new Error('Could not verify that the cart is empty. Please try again.');
    }
  }
  return { detailsReset: true };
}

if (typeof document !== 'undefined') {
  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-tree-clear-cart]') : null;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    event.preventDefault();
    if (!window.confirm('Clear all items and fees from this shopping cart? Saved carts and submitted orders will not be changed.')) return;

    const root = window.Shopify?.routes?.root || '/';
    const base = root.endsWith('/') ? root : `${root}/`;
    const status = button.closest('.tc-cart-clear-row')?.querySelector('[data-tree-clear-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    window.treeCartClearing = true;
    if (status) status.hidden = true;

    try {
      const result = await clearCurrentCart(base);
      if (!result.detailsReset) {
        window.alert('The cart items were cleared, but the PO, note, or discount may remain. Review those details before your next order.');
      }
      window.location.assign(`${base}cart`);
    } catch (error) {
      window.treeCartClearing = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (status) {
        status.textContent = error.message || 'Could not clear the cart. Please try again.';
        status.hidden = false;
      }
    }
  });
}
